import React from 'react';
import cx from 'classnames';
import { Button } from '@carbon/react';

import styles from './FormButtons.module.scss';

const FormButtons = ({
  primaryLabel = 'Primary Button',
  secondaryLabel = 'Secondary Button',
  onSubmit = () => {},
  onAbort = () => {},
}) => {
  return (
    <div className={cx(styles.container)}>
      <Button kind="secondary" onClick={onAbort}>
        {secondaryLabel}
      </Button>
      <Button kind="primary" onClick={onSubmit}>
        {primaryLabel}
      </Button>
    </div>
  );
};

const SingleButton = ({
  primaryLabel = 'Primary Button',
  onAbort = () => {},
}) => {
  return (
    <div className={cx(styles.container)}>
      <Button kind="primary" onClick={onAbort}>
        {primaryLabel}
      </Button>
    </div>
  );
};

export { SingleButton };

export default FormButtons;
